module.exports = __webpack_public_path__ + "assets/ff727cc0ba8c52f3210b96d06f8918c3.mp3";